import { QueryKeysConfig } from "@/config/query-keys";
import { createFileRoute } from "@tanstack/react-router";
import PostsFeed from "@/components/PostsFeed";
import { usePostsLoader } from "@/hooks/network/use-posts-loader";
import { homeJsonLd } from "@/config/seo";
export const Route = createFileRoute("/")({
  component: Home,
  shouldReload() {
    return false;
  },
  async loader(ctx) {
    const load = () => Promise.resolve();
    await load();
  },
  head() {
    return {
      scripts: [{
        type: "application/ld+json",
        children: homeJsonLd
      }]
    };
  }
});
function Home() {
  const getPosts = usePostsLoader();
  const loader = ({
    pageParam
  }: any) => getPosts({
    data: {
      after: pageParam
    }
  });
  return <PostsFeed queryKey={[QueryKeysConfig.rootPosts]} loader={loader} />;
}